var _path, _path2, _path3, _path4, _path5, _path6, _path7, _linearGradient, _path8, _defs, _path9, _path10, _path11, _circle, _defs2, _mask, _linearGradient2, _path12, _linearGradient3, _path13, _linearGradient4, _path14, _linearGradient5, _path15, _linearGradient6, _path16, _linearGradient7, _path17, _linearGradient8, _path18, _linearGradient9, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _linearGradient10, _path26, _linearGradient11, _path27, _linearGradient12, _path28, _linearGradient13, _path29, _linearGradient14, _path30, _linearGradient15, _path31, _linearGradient16, _path32, _path33, _linearGradient17, _path34, _linearGradient18, _path35, _linearGradient19, _path36, _linearGradient20, _path37, _path38, _path39, _path40, _linearGradient21, _path41, _linearGradient22, _path42, _linearGradient23, _path43, _linearGradient24, _path44, _linearGradient25, _path45, _linearGradient26, _path46, _path47, _path48, _path49, _linearGradient27, _path50, _linearGradient28, _path51, _linearGradient29, _path52, _linearGradient30, _path53, _linearGradient31, _path54, _linearGradient32, _path55, _path56, _linearGradient33, _ellipse, _linearGradient34, _path57, _path58, _linearGradient35, _path59, _linearGradient36, _path60, _linearGradient37, _path61, _linearGradient38, _path62, _linearGradient39, _path63, _linearGradient40, _circle2, _circle3, _path64, _path65, _path66, _linearGradient41, _path67, _linearGradient42, _path68, _linearGradient43, _path69, _path70, _path71, _linearGradient44, _path72, _linearGradient45, _path73, _linearGradient46, _path74, _linearGradient47, _path75, _path76, _linearGradient48, _path77, _linearGradient49, _path78, _linearGradient50, _path79, _path80, _linearGradient51, _path81, _path82, _linearGradient52, _path83, _linearGradient53, _path84, _linearGradient54, _path85, _path86, _path87, _path88, _path89, _linearGradient55, _path90, _linearGradient56, _path91, _path92, _linearGradient57, _path93, _path94, _path95, _linearGradient58, _path96, _path97, _path98, _path99, _path100, _linearGradient59, _path101, _linearGradient60, _path102, _linearGradient61, _path103, _linearGradient62, _path104, _linearGradient63, _path105, _linearGradient64, _path106, _linearGradient65, _path107, _linearGradient66, _path108, _linearGradient67, _path109, _path110, _linearGradient68, _path111, _path112, _linearGradient69, _path113, _path114, _linearGradient70, _path115, _path116, _linearGradient71, _path117, _linearGradient72, _path118, _linearGradient73, _path119, _linearGradient74, _path120, _linearGradient75, _path121, _linearGradient76, _path122, _path123, _linearGradient77, _path124, _path125, _path126, _linearGradient78, _path127, _path128, _linearGradient79, _path129, _linearGradient80, _path130, _path131, _linearGradient81, _path132, _linearGradient82, _path133, _linearGradient83, _path134, _path135, _linearGradient84, _path136, _linearGradient85, _path137, _linearGradient86, _path138, _linearGradient87, _path139, _linearGradient88, _path140, _linearGradient89, _path141, _linearGradient90, _path142, _linearGradient91, _path143, _linearGradient92, _path144, _linearGradient93, _path145, _linearGradient94, _path146, _linearGradient95, _path147, _linearGradient96, _path148, _linearGradient97, _path149, _linearGradient98, _path150;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSocialMediaUsers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 800 600",
    viewBox: "0 0 800 600",
    id: "social-media-users",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00759f",
    d: "M124.48 426.53s-21.25-11.18-28.62-27.47c-7.37-16.28-.17-39.1-2.39-46.76 13.6 14.38 21.96 18.55 27.9 35.14 5.94 16.6 4.21 34.43 3.11 39.09zM146.87 453.68s-21.88 17.34-44.91.6c-16.1-13.56-26.81-32.06-26.81-32.06s25.88 3.49 38.83 6.54c12.94 3.05 28.25 18.02 32.89 24.92zM694.08 426.53s21.25-11.18 28.62-27.47c7.37-16.28.17-39.1 2.39-46.76-13.6 14.38-21.96 18.55-27.9 35.14-5.94 16.6-4.22 34.43-3.11 39.09zM671.68 453.68s21.88 17.34 44.91.6c16.1-13.56 26.81-32.06 26.81-32.06s-25.88 3.49-38.83 6.54c-12.94 3.05-28.25 18.02-32.89 24.92z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00759f",
    d: "M228.55 517.95s-21.62 18.66-77.4 4.58c-40.66-10.26-74.16-50.41-74.16-50.41s79.82-30.22 151.56 45.83z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#741aac",
    d: "M226.74 520.46s-42.98-5-84.43-81.69c-30.22-55.89-19.75-134.43-19.75-134.43s115.53 58.1 104.18 216.12z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#741aac",
    d: "M225.09 518.88s-34.18-26.52-29.97-113.59c3.07-63.46 52.68-125.24 52.68-125.24s68.79 109.5-22.71 238.83z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#00759f",
    d: "M586.88 514.71s21.35 18.42 76.43 4.52c40.15-10.13 73.24-49.78 73.24-49.78s-78.82-29.85-149.67 45.26z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#741aac",
    d: "M590.01 520.46s42.98-5 84.43-81.69c30.22-55.89 19.74-134.43 19.74-134.43s-115.52 58.1-104.17 216.12z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#741aac",
    d: "M591.66 518.88s34.18-26.52 29.97-113.59c-3.07-63.46-52.68-125.24-52.68-125.24s-68.79 109.5 22.71 238.83z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 411.181,
    x2: 411.181,
    y1: -1.729,
    y2: 568.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#70b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00008b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M701.06 294.15c0-160.09-129.78-289.87-289.88-289.87-160.09 0-289.88 129.78-289.88 289.87 0 91.32 42.25 220.93 108.24 274.06h363.27c66-53.13 108.25-182.74 108.25-274.06z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "b",
    width: 367,
    height: 267,
    x: 228,
    y: 254,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M377.98 93.48a1.14 1.14 0 1 1-2.279.001 1.14 1.14 0 0 1 2.279-.001zM459.74 164.14a1.14 1.14 0 1 1-1.14-1.14c.63-.01 1.14.51 1.14 1.14zM323.57 181.72a1.14 1.14 0 1 1-2.279.001 1.14 1.14 0 0 1 2.279-.001zM237.03 167.9a1.14 1.14 0 1 1-1.14-1.14c.63-.01 1.14.5 1.14 1.14zM572.32 237.5a1.14 1.14 0 1 1-2.279.001 1.14 1.14 0 0 1 2.279-.001z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#619fff",
    d: "m576.07 161.32 1.21 2.46 2.73.4-1.97 1.92.46 2.71-2.43-1.28-2.44 1.28.47-2.71-1.97-1.92 2.72-.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#90c9ff",
    d: "m294.03 61.14 1.52 3.09 3.41.49-2.47 2.4.59 3.39-3.05-1.6-3.04 1.6.58-3.39-2.46-2.4 3.4-.49zM635 212.07l1.53 3.08 3.4.5-2.46 2.4.58 3.39-3.05-1.6-3.04 1.6.58-3.39-2.46-2.4 3.4-.5z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 186.02,
    cy: 202.91,
    r: 4.03,
    fill: "#90c9ff"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "d",
    width: 80.19,
    height: 80.19,
    x: 480.27,
    y: 48.92,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 1,
    result: "back"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "e",
    width: 80.19,
    height: 80.19,
    x: 480.27,
    y: 48.92,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 231.32,
    x2: 297.985,
    y1: 279.598,
    y2: 324.184,
    gradientTransform: "scale(-1 1) rotate(44.854 128.14 -754.315)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.293,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628,
    stopColor: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M491.94 117.3c15.62 15.7 41.01 15.76 56.71.14 15.7-15.62 15.76-41 .15-56.7-15.62-15.7-41.01-15.76-56.71-.14-15.7 15.61-15.76 41-.15 56.7z",
    mask: "url(#e)"
  })))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 231.32,
    x2: 297.985,
    y1: 279.598,
    y2: 324.184,
    gradientTransform: "scale(-1 1) rotate(44.854 128.14 -754.315)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#88cfda"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#89cfd9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    stopColor: "#c8d9bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822,
    stopColor: "#f0dfa7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe1a0"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M491.94 117.3c15.62 15.7 41.01 15.76 56.71.14 15.7-15.62 15.76-41 .15-56.7-15.62-15.7-41.01-15.76-56.71-.14-15.7 15.61-15.76 41-.15 56.7z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 941.665,
    x2: 781.388,
    y1: 261.254,
    y2: 175.455,
    gradientTransform: "scale(-1 1) rotate(6.794 -708.403 -12288.29)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00008b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M568.17 393.6c-.28-2.37 13.34-49.75 28.49-70.82 15.15-21.07 32.18-60.02 32.18-60.02s5.73 34.64-10.02 57.38c-15.75 22.75-22.44 33.98-22.44 33.98s11-22.18 37.31-23.71c26.31-1.53 19.54 22.56 19.54 22.56s-29.02-41.49-89.28 52.38"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 503.723,
    x2: 607.708,
    y1: 473.19,
    y2: 300.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M532.17 439.55s-41.36 9.63-69.36-7.52c-28-17.14-46.36-41.46-46.36-41.46s31.28-10.53 51.45-6.36c20.17 4.17 37.82 26.99 37.87 25.15.05-1.84-21.52-31.03-23.27-50.23-1.75-19.21 7.37-55.18 7.37-55.18s26.56 20.46 33.17 36.47c6.62 16 11.76 50.55 11.76 50.55s-3.52-30.22 8.72-55.28c12.25-25.06 43.36-45.33 43.36-45.33s11.57 31.28 2.07 61.79c-9.5 30.51-31.51 50.57-31.51 50.57s30.45-21.97 49.24-24.99c18.79-3.01 44.86 13.31 44.86 13.31s-26.66 29.66-47.27 34.98c-20.62 5.33-41.34 2.6-41.34 2.6s28.59.49 45.42 11.87c16.83 11.38 31.15 34.87 31.15 34.87s-39.84 4.72-64.96-8.04c-25.12-12.77-42.37-27.77-42.37-27.77z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 622.586,
    x2: 622.429,
    y1: 513.937,
    y2: 514.707,
    gradientTransform: "rotate(18.924 848.543 304.954)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.074,
    stopColor: "#cec228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#b2ae18"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M571.54 429.23c-5.16-.55-8.61-.62-8.61-.62s3.34.43 8.61.62z"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 560.985,
    x2: 576.344,
    y1: 402.02,
    y2: 402.02,
    gradientTransform: "rotate(-12.552 430.484 641.862)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#70b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00008b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M495.89 326.06s5.07 66.99 36.6 102.87c-4.4-10.04-16.23-27.24-22.79-51.06-6.55-23.81-13.81-51.81-13.81-51.81z"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 478.81,
    x2: 574.892,
    y1: 428.058,
    y2: 428.058,
    gradientTransform: "rotate(-12.552 430.484 641.862)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#70b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00008b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M531.63 431.74s-59.29-17.17-82.2-27.84c-17.01-7.43-24.94-11.21-24.94-11.21s12.85 10.48 49.55 24.63c36.7 14.14 57.59 14.42 57.59 14.42z"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 581.866,
    x2: 661.893,
    y1: 490.142,
    y2: 490.142,
    gradientTransform: "rotate(-12.552 430.484 641.862)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#70b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00008b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M539.07 433.03s36.36 9.66 66.94 25.32c14.47 7.53 23.57 12.95 23.57 12.95s-24.82-11.12-41.91-17.9c-17.09-6.8-48.6-20.37-48.6-20.37z"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 267.506,
    x2: 107.228,
    y1: 322.086,
    y2: 236.286,
    gradientTransform: "rotate(6.783 42.654 366.05)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00008b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M257.48 374.25c.28-2.37-13.34-49.75-28.49-70.82-15.15-21.07-32.18-60.02-32.18-60.02s-5.73 34.64 10.02 57.38c15.75 22.75 22.44 33.98 22.44 33.98s-11-22.18-37.31-23.71c-26.31-1.53-19.54 22.56-19.54 22.56s29.02-41.49 89.28 52.38"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2.31,
    d: "M546.53 271.73s-17.03 25.5-27.68 62.56c-10.66 37.06-6.43 78.65-6.43 78.65"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2.31,
    d: "M540.4 314.23s-13.68 4.36-18.6 10.56c.15-6.82 2.23-31.52 2.23-31.52M531.73 353.79s-13.16 2.23-18.23 7.14c-3.17-7.38-6.1-26.61-6.1-26.61M519.73 387.54s-5.71 3.38-8.14 6.57c-4.28-6.43-15.63-18.45-15.63-18.45"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#00759f",
    d: "M544.46 274.1s16.75-.5 24.05-12.06c7.3-11.56 8.76-21.63 8.76-21.63s-15.49 2.34-24.6 10.47c-9.13 8.14-8.21 23.22-8.21 23.22zM540.4 314.23s9.15-14.2 21.55-20.06c10.98-4.43 26.02 3.79 26.02 3.79s-1.82 11.2-18.61 17.53c-11.18 4.21-22.56 1.41-28.96-1.26zM508.26 337.68s5.85-23.81-5.11-33.21c-10.97-9.39-15.25-11.6-15.25-11.6s-4.35 18.42.45 28.37c4.81 9.96 19.91 16.44 19.91 16.44zM528.43 354.34s14.49-13.91 25.34-13.92c10.85-.01 22.08 4.84 22.08 4.84s-6.8 13.88-23.63 14.29c-16.82.42-23.79-5.21-23.79-5.21zM497.91 377.67s-2.95-18.44-16.76-22.1c-11.76-2.89-16.8-.19-16.8-.19s.57 9.02 7.49 16.57c6.92 7.56 26.07 5.72 26.07 5.72zM518.04 388.54s2.87-10.7 11.95-13.48c9.39-2.71 17.43 2.12 17.43 2.12s-1.18 11.18-11.69 13.75c-10.52 2.57-17.69-2.39-17.69-2.39zM524.57 295.14s6.16-17.5 2.3-25.97c-3.86-8.47-12.35-12.24-12.35-12.24s-6.59 9.78-4.21 19.2 14.26 19.01 14.26 19.01z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2.31,
    d: "M255.37 275.56s23.9 19.2 45.21 51.34c21.31 32.14 29.78 73.08 29.78 73.08"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2.31,
    d: "M273.99 314.25s14.36.04 20.92 4.48c-2.2-6.46-11.6-29.39-11.6-29.39M294.15 349.38s13.22-1.83 19.53 1.33c.8-7.99-2.18-27.21-2.18-27.21M315.74 377.95s6.47 1.51 9.74 3.82c2.15-7.42 9.36-22.3 9.36-22.3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#00759f",
    d: "M258.06 277.2s-16.13 4.56-26.56-4.28-14.86-18-14.86-18 15.48-2.42 26.62 2.59c11.14 5.03 14.8 19.69 14.8 19.69zM273.99 314.25S261 303.46 247.41 301.6c-11.8-.92-23.67 11.44-23.67 11.44s5.1 10.13 23.02 11.12c11.92.65 21.93-5.43 27.23-9.91zM311.7 326.96s-12.74-20.95-5.1-33.21c7.64-12.25 11.06-15.65 11.06-15.65s9.69 16.26 8.1 27.2c-1.61 10.94-14.06 21.66-14.06 21.66zM297.46 348.91s-18-8.91-28.35-5.66c-10.35 3.25-19.61 11.25-19.61 11.25s10.66 11.2 26.83 6.53c16.18-4.66 21.13-12.12 21.13-12.12zM333.59 361.99s-2.73-18.47 9.34-26.11c10.34-6.3 15.96-5.23 15.96-5.23s2.17 8.77-2.16 18.06c-4.33 9.28-23.14 13.28-23.14 13.28zM317.66 378.4s-5.96-9.34-15.45-9.26c-9.77.24-15.99 7.27-15.99 7.27s4.48 10.31 15.28 9.59c10.81-.71 16.16-7.6 16.16-7.6zM283.36 291.29s-11.14-14.84-10-24.08c1.14-9.24 8.11-15.38 8.11-15.38s9.23 7.35 9.78 17.05c.55 9.69-7.89 22.41-7.89 22.41z"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 479.579,
    x2: 573.089,
    y1: 539.12,
    y2: 390.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#59023f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.119,
    stopColor: "#590444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#5a0a53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.426,
    stopColor: "#5c156c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597,
    stopColor: "#5e238f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776,
    stopColor: "#6135bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#644cf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6551ff"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M512.17 523.26s-35.74 22.93-67.87 16.17c-32.13-6.76-57.58-23.53-57.58-23.53s25.95-20.4 46.35-23.23c20.4-2.83 44.68 12.75 44.11 11-.57-1.75-30.67-22.02-38.76-39.53-8.09-17.51-11.55-54.45-11.55-54.45s31.88 10.38 43.48 23.24c11.6 12.86 28.03 43.68 28.03 43.68s-13.44-27.29-10.31-55.01c3.14-27.72 25.66-57.25 25.66-57.25s21.39 25.59 22.66 57.52c1.28 31.93-12.74 58.21-12.74 58.21s21.32-30.91 38.02-40.05c16.7-9.14 46.73-2.5 46.73-2.5s-15.17 36.87-32.81 48.8-38.08 16.31-38.08 16.31 27.1-9.12 46.77-4.04c19.67 5.08 41.04 22.41 41.04 22.41s-35.95 17.8-63.9 14.2c-27.97-3.59-49.25-11.95-49.25-11.95z"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 607.48,
    x2: 607.323,
    y1: 548.854,
    y2: 549.624,
    gradientTransform: "rotate(-.659 -3500.617 6255.81)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.074,
    stopColor: "#cec228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#b2ae18"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M545.81 500.35c-5.04 1.21-8.32 2.3-8.32 2.3s3.28-.71 8.32-2.3z"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 529.913,
    x2: 545.27,
    y1: 424.868,
    y2: 424.868,
    gradientTransform: "rotate(-32.142 586.313 559.17)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#70b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00008b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M439.95 428.5s27.23 61.42 68.97 84.65c-7.51-7.98-24.42-20.22-38.58-40.46-14.17-20.24-30.39-44.19-30.39-44.19z"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 447.733,
    x2: 543.818,
    y1: 450.906,
    y2: 450.906,
    gradientTransform: "rotate(-32.142 586.313 559.17)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#70b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00008b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M509.05 516.09s-61.61 3.69-86.77 1.32c-18.52-1.3-27.25-2.2-27.25-2.2s15.62 5.57 54.94 6.59c39.31 1.03 59.08-5.71 59.08-5.71z"
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 311.025,
    x2: 94.189,
    y1: 433.937,
    y2: 317.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M302.26 436.85s39.34-15.98 52.34-46.14c12.99-30.15 13.97-60.61 13.97-60.61s-31.63 9.44-45.71 24.47c-14.07 15.03-15.34 43.86-16.44 42.38-1.1-1.48-.31-37.75-9.95-54.46-9.64-16.7-37.83-40.83-37.83-40.83s-9.9 32.03-6.08 48.92c3.82 16.89 19.53 48.08 19.53 48.08s-14.55-26.72-39-40.14c-24.46-13.41-61.57-12.04-61.57-12.04s8.58 32.23 33.93 51.68c25.35 19.45 54.9 23.15 54.9 23.15s-37.55-.4-54.64 7.98c-17.09 8.37-28.98 36.74-28.98 36.74s38.88 8.86 58.8 1.32c19.92-7.53 35.28-21.71 35.28-21.71s-23.08 16.88-30.26 35.89c-7.18 19-5.35 46.45-5.35 46.45s35.27-19.11 48.44-44.02c13.18-24.91 18.62-47.11 18.62-47.11z"
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 348.356,
    x2: 348.199,
    y1: 898.863,
    y2: 899.633,
    gradientTransform: "scale(-1 1) rotate(54.134 480.815 70.715)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.074,
    stopColor: "#cec228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#b2ae18"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M264.14 451.12c3.9-3.42 6.67-5.47 6.67-5.47s-2.47 2.27-6.67 5.47z"
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 360.887,
    x2: 263.078,
    y1: 540.138,
    y2: 373.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#59023f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.119,
    stopColor: "#590444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#5a0a53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.426,
    stopColor: "#5c156c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597,
    stopColor: "#5e238f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776,
    stopColor: "#6135bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#644cf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6551ff"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "M335.99 521.72s37.65 19.64 69.05 10.02c31.39-9.62 55.24-28.59 55.24-28.59s-27.67-18-48.24-18.99c-20.57-.99-43.36 16.71-42.94 14.91.42-1.79 28.57-24.68 35.06-42.84 6.49-18.16 6.62-55.27 6.62-55.27s-30.82 13.19-41.22 27.04c-10.4 13.85-24 46.02-24 46.02s10.94-28.38 5.34-55.71c-5.61-27.32-30.69-54.71-30.69-54.71S301.2 391 302.8 422.92c1.59 31.91 17.9 56.83 17.9 56.83s-24.01-28.87-41.45-36.48c-17.45-7.61-46.77 1.7-46.77 1.7s18.42 35.37 37.06 45.67c18.63 10.3 39.39 12.83 39.39 12.83s-27.81-6.66-46.95.17c-19.13 6.83-38.86 26-38.86 26s37.4 14.51 64.91 8.41c27.52-6.1 47.96-16.33 47.96-16.33z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#00759f",
    d: "M320.21 363.6s25.08 27.39 30.69 54.71c5.6 27.32-5.34 55.71-5.34 55.71s13.6-32.17 24-46.02c10.4-13.85 41.22-27.04 41.22-27.04s-.14 37.11-6.62 55.27c-6.49 18.16-34.64 41.05-35.06 42.84-.42 1.8 22.38-15.91 42.94-14.91 20.57.99 48.24 18.99 48.24 18.99s-23.85 18.98-55.24 28.59c-31.4 9.62-69.05-10.02-69.05-10.02s-.35.18-1.01.49c3.2-69.67-14.77-158.61-14.77-158.61z",
    opacity: 0.3
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 228.338,
    x2: 228.181,
    y1: 784.229,
    y2: 784.999,
    gradientTransform: "scale(-1 1) rotate(4.485 3550.266 -6163.56)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.074,
    stopColor: "#cec228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#b2ae18"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "M300.44 501.91c5.13.76 8.49 1.55 8.49 1.55s-3.34-.41-8.49-1.55z"
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 83.972,
    x2: 99.334,
    y1: 427.177,
    y2: 427.177,
    gradientTransform: "scale(-1 1) rotate(-26.996 -56.977 1408.051)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#70b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00008b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    d: "M399.42 420.86s-21.62 63.61-61.1 90.49c6.77-8.62 22.51-22.33 34.8-43.76 12.3-21.42 26.3-46.73 26.3-46.73z"
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 1.792,
    x2: 97.882,
    y1: 453.218,
    y2: 453.218,
    gradientTransform: "scale(-1 1) rotate(-26.996 -56.977 1408.051)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#70b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00008b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    d: "M338.46 514.29s61.7-1.84 86.54-6.46c18.33-2.95 26.95-4.63 26.95-4.63s-15.06 6.94-54.12 11.49c-39.07 4.55-59.37-.4-59.37-.4z"
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 103.623,
    x2: 214.262,
    y1: 476.601,
    y2: 476.601,
    gradientTransform: "scale(-1 1) rotate(-26.996 -56.977 1408.051)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#70b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00008b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#y)",
    d: "M332.73 512.9s-23.29-24.16-44.95-39.97c-21.65-15.82-46.34-24.55-46.34-24.55s32.42 19.42 44.58 28.15c12.15 8.73 46.71 36.37 46.71 36.37z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M330.18 222.53s4.2 20.77-17.24 32.12c-7.17 2.49-20.55 2.72-27.98-4.37 10.91 5.3 20.62 6.19 27.8 3.39 4.07-3.41 15.79-7.86 17.42-31.14z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M318.69 224.67s4.69 17.77-6.04 29.52c-10.65-2.35-19.47-10.48-22.04-16.26 3.45 3.97 12.87 13.34 21.55 15.44 4.06-6.84 8.09-15.48 6.53-28.7z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M311.42 234.47s5.42 12.33 1.61 19.29c-2.03-1.19-11.81-10.04-14.58-23.59 4.06 7.56 5.49 14.3 13.98 21.62 1.08-4.62-.65-15.47-1.01-17.32z"
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 319.909,
    x2: 329.192,
    y1: 160.826,
    y2: 160.826,
    gradientTransform: "rotate(24.512 189.664 202.026)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#z)",
    d: "M330.44 227.04s3.11-1.83 3.46-6.5c.34-4.68-2.43-6.35-3.88-4.35-.63-1.41-1.26-.71-1.27.2-.87-.88-2.6-.93-2.82 1.11-.22 2.04 1.55 9.12 4.51 9.54z"
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 310.728,
    x2: 318.946,
    y1: 167.797,
    y2: 167.797,
    gradientTransform: "rotate(24.512 189.664 202.026)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#A)",
    d: "M318.99 228.31s3.55-2.23 1.92-7.46c-1.01-2.69-2.39-2.9-2.71-2.19-.39-.32-2.05-.57-2.14.86-.83-.44-2.26.74-1.87 2.4.39 1.66 1.31 5.58 4.8 6.39z"
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 309.736,
    x2: 317.057,
    y1: 180.842,
    y2: 180.842,
    gradientTransform: "rotate(24.512 189.664 202.026)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    d: "M312.43 238.73s2.82-1.88 1.18-6.35c-1.05-3.04-2.53-2.02-2.55-1.38-.57-.85-1.53-.69-1.64.06-.82-.39-1.86.78-1.47 2.43.38 1.66 1.6 5.02 4.48 5.24z"
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 293.848,
    x2: 304.244,
    y1: 181.012,
    y2: 181.012,
    gradientTransform: "rotate(24.512 189.664 202.026)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#C)",
    d: "M300.04 234.4s2.72-1.3 1.97-5.49c-.74-4.18-3.04-6.83-3.9-5.15-.84-.64-2.25-1.86-3.53.56-1.53.36-1.28 2.73-.6 4.47.67 1.74 3.15 5.73 6.06 5.61z"
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 289.978,
    x2: 302.128,
    y1: 207.334,
    y2: 207.334,
    gradientTransform: "rotate(24.512 189.664 202.026)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#D)",
    d: "M289.94 253.22s.81-2.9-2.83-5.09-7.15-2.2-6.44-.45c-1.03.21-2.88.47-1.9 3.03-.74 1.39 1.21 2.76 2.97 3.4 1.74.62 6.38 1.38 8.2-.89z"
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: 289.947,
    x2: 299.756,
    y1: 192.639,
    y2: 192.639,
    gradientTransform: "rotate(24.512 189.664 202.026)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  }))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#E)",
    d: "M292.95 240.74s1.31-1.33-.31-4.19c-1.06-2.14-4.35-5.76-4.86-2.99-1.53.03-3.28-.37-2.55 2.73-1.39.81-.15 2.28 1.26 3.71 1.41 1.44 5.08 1.93 6.46.74z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M313.63 252.45s.06.11.17.32c1.89 3.63 18.71 36.65 11.96 46.89.67-5.21-.15-11.73-4.77-24.88-4.62-13.15-8.82-21.4-8.82-21.4l1.53-.82M478.69 229.69s-4.2 20.77 17.24 32.12c7.18 2.49 20.55 2.72 27.98-4.37-10.91 5.3-20.62 6.19-27.8 3.39-4.06-3.4-15.78-7.85-17.42-31.14z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M490.18 231.84s-4.69 17.77 6.04 29.52c10.65-2.35 19.47-10.48 22.04-16.26-3.45 3.97-12.87 13.34-21.55 15.44-4.06-6.84-8.08-15.48-6.53-28.7z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M497.45 241.64s-5.42 12.33-1.61 19.29c2.03-1.19 11.81-10.04 14.58-23.59-4.06 7.56-5.49 14.3-13.98 21.62-1.07-4.62.66-15.47 1.01-17.32z"
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 554.486,
    x2: 563.769,
    y1: 61.739,
    y2: 61.739,
    gradientTransform: "scale(-1 1) rotate(24.512 -342.035 -2245.572)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  }))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#F)",
    d: "M478.43 234.21s-3.11-1.83-3.46-6.5c-.34-4.68 2.43-6.35 3.88-4.35.63-1.41 1.26-.71 1.27.2.87-.88 2.6-.93 2.82 1.11.23 2.04-1.55 9.11-4.51 9.54z"
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: 545.306,
    x2: 553.523,
    y1: 68.71,
    y2: 68.71,
    gradientTransform: "scale(-1 1) rotate(24.512 -342.035 -2245.572)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#G)",
    d: "M489.89 235.48s-3.55-2.23-1.92-7.46c1.01-2.69 2.39-2.9 2.71-2.19.39-.32 2.05-.57 2.14.86.83-.44 2.26.74 1.87 2.4-.39 1.66-1.31 5.58-4.8 6.39z"
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: 544.313,
    x2: 551.635,
    y1: 81.756,
    y2: 81.756,
    gradientTransform: "scale(-1 1) rotate(24.512 -342.035 -2245.572)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#H)",
    d: "M496.45 245.9s-2.82-1.88-1.18-6.35c1.05-3.04 2.53-2.02 2.55-1.38.57-.85 1.53-.69 1.64.06.82-.39 1.86.78 1.47 2.43-.38 1.65-1.61 5.02-4.48 5.24z"
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: 528.425,
    x2: 538.821,
    y1: 81.926,
    y2: 81.926,
    gradientTransform: "scale(-1 1) rotate(24.512 -342.035 -2245.572)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#I)",
    d: "M508.84 241.56s-2.72-1.3-1.97-5.49c.74-4.18 3.04-6.83 3.9-5.15.84-.64 2.25-1.86 3.53.56 1.53.36 1.28 2.73.61 4.47-.68 1.75-3.17 5.74-6.07 5.61z"
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: 524.556,
    x2: 536.706,
    y1: 108.248,
    y2: 108.248,
    gradientTransform: "scale(-1 1) rotate(24.512 -342.035 -2245.572)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  }))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#J)",
    d: "M518.94 260.38s-.81-2.9 2.83-5.09 7.15-2.2 6.44-.45c1.03.21 2.88.47 1.9 3.03.74 1.39-1.21 2.76-2.97 3.4-1.75.63-6.38 1.39-8.2-.89z"
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    x1: 524.525,
    x2: 534.334,
    y1: 93.552,
    y2: 93.552,
    gradientTransform: "scale(-1 1) rotate(24.512 -342.035 -2245.572)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#K)",
    d: "M515.93 247.91s-1.31-1.33.31-4.19c1.06-2.14 4.35-5.76 4.86-2.99 1.53.03 3.28-.37 2.55 2.73 1.39.81.15 2.28-1.26 3.71-1.41 1.44-5.08 1.93-6.46.74z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M495.25 259.61s-.06.11-.17.32c-1.89 3.63-18.71 36.65-11.96 46.89-.67-5.21.15-11.73 4.77-24.88 4.62-13.15 8.82-21.4 8.82-21.4l-1.53-.82"
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    x1: 416.509,
    x2: 416.509,
    y1: 615.104,
    y2: 547.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#70b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.118,
    stopColor: "#6300b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.393,
    stopColor: "#3800a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#190095"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#07008e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00008b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 416.51,
    cy: 572.58,
    fill: "url(#L)",
    rx: 293.43,
    ry: 23.11
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    x1: 384.715,
    x2: 387.142,
    y1: 549.952,
    y2: 566.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#270036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#4f008b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c24b1"
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#M)",
    d: "m303.08 568.53 3.63-12.14s.84-3.77 8.23-3.77h144.38s6.84-.3 8.79 4.74c2.6 6.71 3.35 10.04 3.35 10.04s2.37 5.16-6.42 5.16H306.99s-3.91.3-3.91-4.03z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M306.98 572.58h158.05c6.15 0 6.83-2.53 6.69-4.05H303.08c0 4.33 3.9 4.05 3.9 4.05z"
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    x1: 386.588,
    x2: 386.588,
    y1: 529.966,
    y2: 300.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#270036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#4f008b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c24b1"
  }))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#N)",
    d: "M561.24 517.06c0 9.24-7.5 16.74-16.74 16.74H228.68c-9.24 0-16.74-7.5-16.74-16.74V316.93c0-9.24 7.5-16.74 16.74-16.74H544.5c9.25 0 16.74 7.49 16.74 16.74v200.13z"
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    x1: 387.518,
    x2: 387.518,
    y1: 504.478,
    y2: 312.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#4e53ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.436,
    stopColor: "#2c6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.646,
    stopColor: "#1480ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#058cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  }))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#O)",
    d: "M229.05 316.56h316.94v180.42H229.05z"
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    x1: 321.464,
    x2: 555.006,
    y1: 391.627,
    y2: 187.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1baff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#a7bfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#c3d3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    stopColor: "#d9e3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.274,
    stopColor: "#eaf0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#f6f8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#fdfeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#P)",
    d: "M229.05 316.56h316.94v34.57H229.05z"
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    x1: 334.762,
    x2: 470.084,
    y1: 362.37,
    y2: 243.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#4e53ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.436,
    stopColor: "#2c6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.646,
    stopColor: "#1480ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#058cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  }))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Q)",
    d: "M472.63 328.89c0 1.66-1.34 3-3 3h-193.2c-1.66 0-3-1.34-3-3s1.34-3 3-3h193.2c1.66 0 3 1.34 3 3z",
    opacity: 0.5
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "R",
    x1: 309.337,
    x2: 390.331,
    y1: 361.822,
    y2: 290.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#4e53ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.436,
    stopColor: "#2c6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.646,
    stopColor: "#1480ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#058cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  }))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#R)",
    d: "M391.05 341.78c0 1.66-.79 3-1.77 3H275.21c-.98 0-1.77-1.34-1.77-3s.79-3 1.77-3h114.07c.98 0 1.77 1.34 1.77 3z",
    opacity: 0.5
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    x1: 243.032,
    x2: 265.994,
    y1: 339.52,
    y2: 319.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#4e53ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.436,
    stopColor: "#2c6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.646,
    stopColor: "#1480ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#058cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 249.53,
    cy: 333.84,
    r: 12.85,
    fill: "url(#S)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 249.1,
    cy: 328.49,
    r: 6.07,
    fill: "#fff"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M259.25 342.22c-1.8-3.81-5.66-6.45-10.15-6.45-4.23 0-7.91 2.34-9.82 5.79 2.34 3.11 6.06 5.12 10.25 5.12 3.89 0 7.36-1.73 9.72-4.46z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M408.92 374.16c0 8.26-8.24 14.96-18.41 14.96s-18.41-6.7-18.41-14.96c0-8.26 8.24-14.96 18.41-14.96 10.16.01 18.41 6.7 18.41 14.96z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#431ca3",
    d: "M332.3 497.62s2.17-27.62 22.74-34.93c20.58-7.31 57.67-6.5 72.02 0 14.35 6.5 20.58 15.43 22.47 23.83 1.9 8.39 1.63 11.1 1.63 11.1H332.3z"
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    x1: 373.383,
    x2: 411.76,
    y1: 471.512,
    y2: 471.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1baff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#a7bfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#c3d3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    stopColor: "#d9e3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.274,
    stopColor: "#eaf0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#f6f8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#fdfeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#T)",
    d: "M392.57 485.51c10.6 0 19.19-8.55 19.19-19.09 0-2.8-.61-5.45-1.7-7.85-10.54-1.33-23.26-1.44-34.92-.14a18.863 18.863 0 0 0-1.76 7.98c0 10.55 8.59 19.1 19.19 19.1z"
  })), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "U",
    x1: 375.142,
    x2: 410.063,
    y1: 451.564,
    y2: 451.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1baff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#a7bfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#c3d3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    stopColor: "#d9e3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.274,
    stopColor: "#eaf0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#f6f8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#fdfeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#U)",
    d: "M375.14 458.44s5.45-3.32 5.45-10.2 23.87-2.02 23.87-2.02 2.37 9.93 5.61 12.35"
  })), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "V",
    x1: 362.184,
    x2: 421.61,
    y1: 428.989,
    y2: 428.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1baff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#a7bfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#c3d3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    stopColor: "#d9e3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.274,
    stopColor: "#eaf0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#f6f8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#fdfeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#V)",
    d: "M370.74 444.56c-3.93-7.17-3.25-9.34-3.25-9.34s-5.01-3.38-5.28-9.07c-.27-5.69 1.35-6.23 1.35-6.23h4.6s.27-8.51 5.21-14.41c4.94-5.9 6.16-7.11 6.16-7.11s8.53 5.02 16.65 7.11c8.12 2.09 15.7 5.75 17.73 9.94l2.03 4.2s4.74-1.76 5.41 1.35c.68 3.11-.14 9.48-1.9 10.83-1.76 1.35-3.38 1.08-3.38 1.08s-1.76 10.02-7.04 15.97c-5.28 5.96-11.2 10.69-16.48 10.69-7.3.01-17.88-7.84-21.81-15.01z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M367.49 428.99s-7.31-10.69-7.85-20.58c-.54-9.88 1.62-20.03 6.5-24.37 4.87-4.33 11.78-3.79 11.78-3.79s5.14-5.55 19.76-3.65c14.62 1.9 19.49 10.15 23.01 18.14 3.52 7.99.29 17.81-.68 21.12-.96 3.31-3.66 10.42-3.66 10.42s-.2-7.94-3.28-12.16c-3.08-4.22-11.46-6.99-16.21-8.43-4.75-1.44-12.02-4.39-14.68-5.84l-2.65-1.45s-7.98 7.85-9.41 12.7c-1.42 4.84-2.63 17.89-2.63 17.89z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.678,
    d: "M382.12 508.88c0-2.47 2-4.46 4.46-4.46s4.46 2 4.46 4.46-2 4.46-4.46 4.46-4.46-2-4.46-4.46z"
  })), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "W",
    x1: 212.006,
    x2: 561.17,
    y1: 526.174,
    y2: 526.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1baff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#W)",
    d: "M212.01 518.55c.75 8.55 7.93 15.25 16.67 15.25H544.5c8.74 0 15.92-6.7 16.67-15.25H212.01z"
  })), _linearGradient45 || (_linearGradient45 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "X",
    x1: 371.988,
    x2: 402.677,
    y1: 546.494,
    y2: 546.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#270036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#4f008b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c24b1"
  }))), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#X)",
    d: "M371.99 533.8h30.69v25.39h-30.69z"
  })), _linearGradient46 || (_linearGradient46 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Y",
    x1: 385.285,
    x2: 428.31,
    y1: 248.628,
    y2: 248.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  }))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Y)",
    d: "M411.84 215.36s4.55 3.72 5.92 4.32c1.37.61 6.52 1.37 7.21 2.5.68 1.14.3 9.71 1.29 13.35.99 3.64 2.88 11 1.67 14.11-1.21 3.11-3.34 4.93-3.34 5.99 0 1.06-.68 12.59-.68 12.59s-15.78 4.1-24.65 8.19-13.96 8.27-13.96 8.27 2.96-6.9 4.48-12.29c1.52-5.39 3.87-14.72 3.79-17.75-.08-3.03-7.13-37.02-7.13-37.02s2.43.38 3.64.15 6.6-2.2 8.42-3.26c1.82-1.06 2.43-1.97 2.43-1.97l10.91 2.82z"
  })), _linearGradient47 || (_linearGradient47 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Z",
    x1: 425.186,
    x2: 467.669,
    y1: 253.454,
    y2: 253.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1baff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#a7bfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#c3d3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    stopColor: "#d9e3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.274,
    stopColor: "#eaf0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#f6f8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#fdfeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Z)",
    d: "M433.38 239.26s34.59-2.73 34.29-1.97c-.3.76-7.43 28.37-7.43 28.37l-35.05 4.1 8.19-30.5z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "m467.67 237.29-1.14-.91-34.36 1.74-8.27 31.1 1.29.53 8.19-30.49zM424.12 267.86l-12.36-.68v1.74l12.14.3z"
  })), _linearGradient48 || (_linearGradient48 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: 411.759,
    x2: 424.63,
    y1: 266.91,
    y2: 266.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1baff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#a7bfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#c3d3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    stopColor: "#d9e3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.274,
    stopColor: "#eaf0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#f6f8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#fdfeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aa)",
    d: "m411.76 267.18 12.87-1.22-.51 1.9z"
  })), _linearGradient49 || (_linearGradient49 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: 419.713,
    x2: 426.349,
    y1: 262.491,
    y2: 262.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1baff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#a7bfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#c3d3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    stopColor: "#d9e3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.274,
    stopColor: "#eaf0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#f6f8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#fdfeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ab)",
    d: "M426.35 259.18s-1.67-.25-3.89 0l-2.22.25s-.61 2.43-.51 4.05c.1 1.62.05 2.43.05 2.43l4.8-.3 1.77-6.43z"
  })), _linearGradient50 || (_linearGradient50 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    x1: 391.659,
    x2: 419.233,
    y1: 223.335,
    y2: 223.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1baff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#a7bfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#c3d3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    stopColor: "#d9e3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.274,
    stopColor: "#eaf0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#f6f8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#fdfeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ac)",
    d: "M391.66 217.33c2.11-.7 5.46-2 6.82-2.8 1.82-1.06 2.43-1.97 2.43-1.97l10.92 2.81s4.55 3.72 5.92 4.32c.32.14.85.29 1.48.45-.02.05-.04.08-.04.08s-.61 5.99-2.12 9.56c-1.52 3.57-3.72 4.02-6.14 4.32s-8.95-5.31-12.59-9.25c-2.62-2.84-5.35-5.98-6.68-7.52z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M403.49 182.75s-6.22-.99-7.51 2.2c-1.29 3.19-.76 13.96-1.97 17.45-1.21 3.49-1.52 5.61-1.74 7.66-.23 2.05-.38 2.43-1.37 3.72-.99 1.29-1.67 3.79-1.67 3.79s1.21.38 4.85-1.06c3.64-1.44 6.83-3.94 6.83-3.94l2.58-29.82z"
  })), _linearGradient51 || (_linearGradient51 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    x1: 395.672,
    x2: 421.09,
    y1: 204.751,
    y2: 204.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1baff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#a7bfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#c3d3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    stopColor: "#d9e3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.274,
    stopColor: "#eaf0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#f6f8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#fdfeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ad)",
    d: "M421.09 194.12s-.91 5.16-1.82 7.28-1.29 3.19-1.29 3.19-.83 5.92-4.32 9.94-5.54 3.79-7.59 3.11c-2.05-.68-5.99-4.55-6.45-8.65-.46-4.1-.46-4.48-.46-4.48s-2.81-.23-3.34-3.19.3-5.92 2.2-5.23c1.9.68 2.12 5.54 2.12 5.54s3.41-7.13 5.01-8.5c1.59-1.37 6.6-2.12 9.1-1.37 2.52.77 6.84 2.36 6.84 2.36z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M421.09 194.12s.99-3.34-2.28-7.89c-3.26-4.55-9.63-6.75-14.56-3.87s-6.9 7.51-7.28 9.79c-.38 2.28-.53 4.17-.53 4.17s1.21-.91 2.28.46c1.06 1.37 1.44 4.85 1.44 4.85s1.21-.38 2.05-2.58c.83-2.2 2.81-5.92 4.48-6.6s4.7-1.14 6.45-.76 7.95 2.43 7.95 2.43z"
  })), _linearGradient52 || (_linearGradient52 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    x1: 424.959,
    x2: 434.492,
    y1: 237.813,
    y2: 237.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  }))), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ae)",
    d: "M424.96 222.19s3.87-1.39 5.59 2.55c1.72 3.94 3.94 13.25 3.94 13.25l-2.33.13-4.35 15.55-.91-2.12s1.82-1.31 1.31-5.77c-.51-4.45-2.33-11.02-2.53-13.45-.19-2.43-.72-10.14-.72-10.14z"
  })), _linearGradient53 || (_linearGradient53 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    x1: 385.172,
    x2: 457.754,
    y1: 293.17,
    y2: 293.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#270036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#4f008b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c24b1"
  }))), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#af)",
    d: "M385.28 284.7s10.67-7.66 18.66-10.39c7.99-2.73 16.59-5.06 16.59-5.06l3.36-.03 1.69.63 16.49-2.12s4.85 5.66 8.19 16.89 4.15 19.92 4.96 22.86c.81 2.93 2.53 6.17 2.53 6.17s-2.63 2.33-5.36 3.64l-2.73 1.32s-7.38-13.35-9-19.02l-1.62-5.66s-1.92-11.43-7.79-12.54c-5.87-1.11-8.09 5.97-9.91 10.11-1.82 4.15-6.37 9.71-9.71 10.32s-17.09.2-20.03-1.01c-2.93-1.22-7.17-7.34-6.32-16.11z"
  })), _linearGradient54 || (_linearGradient54 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    x1: 413.15,
    x2: 439.917,
    y1: 311.013,
    y2: 311.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#311842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461,
    stopColor: "#190c4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000054"
  }))), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ag)",
    d: "M413.17 301.24c3.08-1.64 6.62-6.2 8.17-9.74 1.82-4.15 4.05-11.23 9.91-10.11 5.87 1.11 7.79 12.54 7.79 12.54s0 .01.31 1.1c-.01.13-.01.21-.01.21s1.21 10.11.1 17.8c-1.11 7.69-4.48 27.71-4.48 27.71s-8.37-.3-8.37-.61-.71-11.83-1.42-17.19c-.71-5.36-1.42-12.14-1.42-16.49s.1-5.66.1-5.66l-10.72.61c.02 0 .03-.06.04-.17z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M434.59 340.76s-.3 4.55-.3 6.75.46 8.57-.99 12.82c-1.44 4.25-2.96 7.36-6.75 7.74-3.79.38-5.23-1.74-5.39-4.7-.15-2.96.38-6.45 1.9-11.53 1.52-5.08 3.49-7.59 3.49-7.59l.53-3.94 7.51.45z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M424.59 347.73c1.06-2.33 1.96-3.48 1.96-3.48l.53-3.94 7.51.46s-.3 4.55-.3 6.75c0 .73.05 1.92.06 3.34-.91-.29-1.95-.64-2.11-.76-.3-.23-1.67-2.58-3.49-2.12-1.82.46-2.66.91-2.66.91l-1.5-1.16z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "m457.5 314.06 3.11 4.1s.76 0 1.97.3 9.63 1.97 11.53 1.59 5.46-.61 6.6.3c1.14.91 1.44 2.81 1.44 2.81s-4.02 4.17-8.04 5.54-12.52 3.79-14.49 4.63c-1.97.83-6.52 1.29-6.52 1.29s-1.82-5.39-2.2-7.28c-.38-1.9.23-4.93.23-4.93l-1.37-4.02c0-.01 5.62-2.06 7.74-4.33z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M460.61 318.15s-.46 3.79-1.06 4.48c-.61.68-3.49 2.5-4.17 2.2-.68-.3-1.82-2.35-2.43-2.43-.61-.08-1.82 0-1.82 0l-1.47-3.79s3.14-1.52 4.96-2.58 2.88-1.97 2.88-1.97l3.11 4.09z"
  })), _linearGradient55 || (_linearGradient55 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    x1: 365.774,
    x2: 405.667,
    y1: 241.836,
    y2: 241.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  }))), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ah)",
    d: "M420.23 259.44s-16.06-1.59-19.7-3.03c-3.64-1.44-5.54-4.32-5.77-5.99-.23-1.67-1.29-20.71-2.2-24.65s-3.57-8.04-6.9-8.04c-3.34 0-5.08 4.63-5.31 11.76-.23 7.13 1.97 22.45 4.02 26.85 2.05 4.4 4.89 6.21 8.65 7.74 5.77 2.35 26.75 1.85 26.75 1.85s.06-3.61.46-6.49z"
  })), _linearGradient56 || (_linearGradient56 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    x1: 626.692,
    x2: 513.821,
    y1: 449.54,
    y2: 447.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#624bff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#3f76ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2498ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.686,
    stopColor: "#10b0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.857,
    stopColor: "#04bfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00c4ff"
  }))), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ai)",
    d: "M540.07 398.31s-6.68 4.02-7.81 6.9c-1.14 2.88-4.7 14.11-6.37 20.18s-4.93 15.7-4.1 18.05c.83 2.35 9.1 8.65 9.1 8.65s1.21-1.67 2.35-3.64 2.05-2.88 2.05-2.88l-5.16-5.01 8.42-18.05s2.73 6.37 3.26 9.41.08 9.25-1.14 12.29c-1.21 3.03-5.61 12.9-6.75 17.83s1.97 37.63 1.97 37.63 6.98 2.5 21.62 2.05c14.64-.46 22.61-2.88 22.61-2.88s-5.84-29.74-7.21-40.28c-1.37-10.54-1.97-19.8-1.97-23.59s.53-5.31.53-5.31.91-1.59 1.37-2.73l.46-1.14s5.69 10.32 8.12 11.45c2.43 1.14 5.61.15 7.51-2.58 1.9-2.73 8.42-13.05 8.42-13.05l-5.92-5.92-6.83 8.65s-8.19-22.38-9.71-24.81c-1.52-2.43-3.34-3.72-6.14-4.17-2.81-.46-3.94.08-3.94.08l-24.74 2.87z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#881fa4",
    d: "M545.38 409.23s1.9 12.21 2.66 23.9c.76 11.68 0 21.7 0 21.7l-10.32-3.03-.61-26.25-3.03 6.37-.41 11.88 1.57 1.47-1.82 2.68-.1 5.97s-2.88 2.12-4.4 6.68-1.82 8.8-1.82 8.8l.91.61s-1.21 6.98-.46 9.25c.76 2.28 4.1 6.83 8.95 7.89s11.99.91 14.26-.15 3.19-3.64 3.19-6.22c0-2.58-.46-20.03-2.43-36.72-1.97-16.69-3.34-31.86-3.34-31.86l-2.8-2.97z"
  })), _linearGradient57 || (_linearGradient57 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aj",
    x1: 548.915,
    x2: 571.62,
    y1: 384.932,
    y2: 384.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1baff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#a7bfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#c3d3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    stopColor: "#d9e3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.274,
    stopColor: "#eaf0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#f6f8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#fdfeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aj)",
    d: "M553.27 376.08s1.97-.76 2.88-2.81c.91-2.05 2.43-3.11 3.87-3.64 1.44-.53 4.32-2.05 5.46-4.17s1.9-4.02 1.9-4.02 3.26 2.58 3.57 4.85c.3 2.28-.08 6.14-.08 7.13 0 .99 1.59 4.25.15 7.74-1.44 3.49-5.01 9.25-6.3 9.86s-3.03 0-3.03 0l-.3 3.19 3.41 1.21s3.11 7.05 3.11 8.95-1.9 4.93-6.22 3.79c-4.32-1.14-7.05-3.64-8.27-5.01s-1.82-2.43-1.82-2.43 1.44-3.79 1.52-6.37c.08-2.58.15-6.07.15-7.66s-.99-5.01-.99-5.01-3.72-3.11-3.34-5.54 3.42-2.56 4.33-.06z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M575.49 367.74c-1.21-4.93-3.03-7.97-4.78-9.71-1.74-1.74-8.42-1.82-8.42-1.82s-6.37-1.37-11.3.53c-4.93 1.9-10.39 8.19-12.14 17.52-1.74 9.33-.99 17.37.53 22.53s3.79 9.1 5.99 12.44 6.75 6.52 6.75 6.3c0-.23-1.21-12.67-.53-14.79 0 0 1.44-3.79 1.52-6.37.08-2.58.15-6.07.15-7.66s-.99-5.01-.99-5.01-3.72-3.11-3.34-5.54 3.41-2.58 4.32-.08c0 0 1.97-.76 2.88-2.81.91-2.05 2.43-3.11 3.87-3.64 1.44-.53 4.32-2.05 5.46-4.17s1.9-4.02 1.9-4.02 3.26 2.58 3.57 4.85c.3 2.28-.08 6.14-.08 7.13 0 .99 1.59 4.25.15 7.74-1.44 3.49-5.01 9.25-6.3 9.86s-3.03 0-3.03 0l-.3 3.19.57.2c.07-.03.11-.05.11-.05h2.96s4.63-2.96 6.45-6.6c1.83-3.64 5.25-15.09 4.03-20.02z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M531.49 451.11s9.41 6.68 9.94 7.36c.53.68 2.66 5.69 7.59 6.75s5.03.53 5.03.53 2.4-2.73 1.42-3.64c-.99-.91-4.32-2.5-5.31-3.64s-2.02-2.93-2.02-2.93v-1.47l-4.27-.15-9.18-7.81c-.01-.01-2.74 3.63-3.2 5z"
  })), _linearGradient58 || (_linearGradient58 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    x1: 591.802,
    x2: 612.219,
    y1: 407.329,
    y2: 407.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1baff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#a7bfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#c3d3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    stopColor: "#d9e3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.274,
    stopColor: "#eaf0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#f6f8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#fdfeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ak)",
    d: "M591.8 416.29s3.57-5.69 3.57-5.99-1.37-4.48-1.06-6.6c.3-2.12.23-7.81 1.14-7.21.91.61 1.74 2.5 1.74 2.5l.76 1.21s13.2-6.52 13.65-6.14c.46.38.91 1.06.38 1.82s-4.02 2.88-4.02 2.88 1.59.76 1.21 2.35-1.21.76-1.21.99.15 2.2-1.21 4.32c-1.37 2.12-5.46 5.69-5.46 5.69l-4.63 8.5-4.86-4.32z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "m599.69 392.09-5.46 15.55s-.08 1.06 1.06 1.21c1.14.15 7.05-.08 7.05-.08s.83-.23 1.14-1.44c.3-1.21 4.25-14.41 4.25-14.41s-.08-.68-.76-.83-7.28 0-7.28 0z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m599.99 393.46-4.24 12.82 6.37-.08 3.87-12.67z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M607.5 398.69s-3.72 1.37-4.55 2.12c-.83.76-.68 1.44-.08 1.59.61.15 5.69-.46 5.69-.46s.61-.38.68-1.52-.98-1.65-1.74-1.73z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M607.66 402.18s-4.25.08-5.08.83c-.83.76.23 1.74.83 1.9.61.15 4.32-.3 4.32-.3s1.21-.08 1.29-1.21c.08-1.15-.61-1.15-1.36-1.22zM606.97 404.91s-3.31.06-3.97.65c-.65.59.18 1.36.65 1.48.47.12 3.37-.24 3.37-.24s.95-.06 1.01-.95c.07-.88-.47-.88-1.06-.94z"
  })), _linearGradient59 || (_linearGradient59 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "al",
    x1: 538.727,
    x2: 553.811,
    y1: 541.677,
    y2: 541.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1baff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#a7bfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#c3d3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    stopColor: "#d9e3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.274,
    stopColor: "#eaf0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#f6f8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#fdfeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#al)",
    d: "M538.73 500.39s1.72 10.82 1.62 13.05c-.1 2.23-.4 18.71.3 24.68.71 5.97 3.54 21.14 3.74 24.48s-.2 9.71-.61 12.64-.81 6.68.2 7.38c1.01.71 7.59.2 7.99-.4.4-.61-2.12-10.92-2.12-13.35 0-2.43 1.52-23.57 1.72-28.83s-.61-11.23-.3-16.49c.3-5.26.81-10.11 1.62-15.78s1.11-6.07.81-6.07c-.31 0-9.81.41-14.97-1.31z"
  })), _linearGradient60 || (_linearGradient60 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "am",
    x1: 561.282,
    x2: 597.874,
    y1: 539.441,
    y2: 539.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1baff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#a7bfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#c3d3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    stopColor: "#d9e3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.274,
    stopColor: "#eaf0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#f6f8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#fdfeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#am)",
    d: "M561.28 501.6s3.14 10.92 3.44 15.07c.3 4.15.2 11.02 1.92 16.39 1.72 5.36 8.6 18 10.01 21.34 1.42 3.34 2.53 6.17 1.82 7.69-.71 1.52-1.31 1.82-1.92 3.44-.61 1.62.4 3.84.4 3.84s6.68.91 8.29 3.14c1.62 2.23 5.16 6.07 6.78 6.47 1.62.4 4.55.2 5.36-.2s.71-1.72-1.11-2.43-3.54-1.21-4.75-3.03c-1.21-1.82-6.17-10.11-7.08-13.65-.91-3.54-7.49-42.48-7.38-45.72.1-3.24.51-2.93.1-7.59s-.51-6.68-.51-6.68-11.83 2.13-15.37 1.92z"
  })), _linearGradient61 || (_linearGradient61 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "an",
    x1: 576.585,
    x2: 598.734,
    y1: 574.646,
    y2: 574.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#270036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#4f008b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c24b1"
  }))), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#an)",
    d: "m578.75 579.46 1.59.08s.3-7.36.99-7.28c.68.08 3.26.38 4.93 2.66s3.57 4.78 5.16 4.93c1.59.15 6.83.08 7.05-.08.23-.15.78-.91-1.09-.99-1.87-.08-5.82-.08-5.82-.08s-3.64-2.81-4.55-4.17c-.91-1.37-1.9-3.03-4.1-3.79-2.2-.76-5.97-1.37-5.97-1.37s-.63 1.37-.25 1.82c.38.46 1.52 1.14 1.67 2.43.17 1.29.39 5.84.39 5.84z"
  })), _linearGradient62 || (_linearGradient62 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ao",
    x1: 585.253,
    x2: 597.732,
    y1: 574.122,
    y2: 574.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#270036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#4f008b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c24b1"
  }))), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ao)",
    d: "M585.51 572.25s1.06-.15 2.12-1.06 1.37-1.97 1.37-1.97 2.81 5.01 3.94 5.61 4.17 1.37 4.63 2.2c.46.83-.18 1.74-.18 1.74s-4.53.61-5.82-.08c-1.29-.68-6.32-6.2-6.32-6.2"
  })), _linearGradient63 || (_linearGradient63 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ap",
    x1: 543.353,
    x2: 552.086,
    y1: 578.811,
    y2: 578.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#270036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#4f008b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c24b1"
  }))), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ap)",
    d: "M543.78 575.24s3.11 1.57 4.93.81c1.82-.76 2.12-1.44 2.12-1.44s1.06 5.92 1.06 6.6.99 1.21-1.59 1.59c-2.58.38-6.68.38-6.9-.91-.22-1.29.38-6.65.38-6.65z"
  })), _linearGradient64 || (_linearGradient64 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aq",
    x1: 571.378,
    x2: 590.31,
    y1: 419.822,
    y2: 419.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#4e53ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.436,
    stopColor: "#2c6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.646,
    stopColor: "#1480ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#058cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  }))), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aq)",
    d: "M573.29 425.77s2.25-2.05 1.85-6.9c-.4-4.85-2.43-12.54-3.64-16.59-1.21-4.05 7.08 27.31 11.53 29.53s7.28.61 7.28.61-3.03 5.87-7.48 5.26-9.31-11.13-9.31-11.13"
  })), _linearGradient65 || (_linearGradient65 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar",
    x1: 181.621,
    x2: 196.92,
    y1: 436.5,
    y2: 436.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1baff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#a7bfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#c3d3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    stopColor: "#d9e3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.274,
    stopColor: "#eaf0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#f6f8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#fdfeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ar)",
    d: "M189.33 408.2s-2.23 15.37-4.65 30.85-3.44 20.94-2.93 23.06c.51 2.12 1.11 2.93 1.11 2.63s14.06-51.08 14.06-51.38-4.65-5.06-4.65-5.06l-2.94-.1z"
  })), _linearGradient66 || (_linearGradient66 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "as",
    x1: 182.153,
    x2: 236.488,
    y1: 429.24,
    y2: 429.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#4e53ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.436,
    stopColor: "#2c6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.646,
    stopColor: "#1480ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#058cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  }))), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#as)",
    d: "M206.23 389.69s-.71 3.24.91 4.96c1.62 1.72 7.28 1.72 9.41.1 2.12-1.62 5.66-5.77 5.66-5.77s9.1.2 11.02 3.54 4.55 12.34 2.53 22.05-6.88 24.88-9.31 32.37-3.84 12.24-4.25 15.27c-.4 3.03-.3 6.78-.3 6.78s-8.5 2.23-23.47-2.63-16.28-5.66-16.28-5.66 3.24-10.52 5.26-22.55 4.25-29.74 4.25-29.74l-3.44-.61s5.87-13.55 11.53-16.18c5.67-2.64 6.48-1.93 6.48-1.93z"
  })), _linearGradient67 || (_linearGradient67 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "at",
    x1: 201.265,
    x2: 226.051,
    y1: 379.436,
    y2: 379.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1baff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#a7bfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#c3d3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    stopColor: "#d9e3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.274,
    stopColor: "#eaf0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#f6f8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#fdfeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#at)",
    d: "M221.8 389.08s-.1-2.53.1-5.87c.2-3.34.3-4.15.3-4.15s3.94-4.96 3.84-7.28c-.1-2.33-2.23-2.33-3.34-1.11-1.11 1.21-2.53 2.33-2.53 2.33l-1.62-.2-5.77-4.25s0-5.36-1.21-5.56-5.06 1.01-6.37.51c-1.32-.51-2.23-1.21-2.23-.81s-1.82 5.87-1.72 7.69 1.52 3.14 1.31 4.15c-.2 1.01-.91 4.45-.61 5.36s2.63 2.02 2.63 2.02.1 5.66.71 6.68c.61 1.01.91 1.11.91 1.11s-.91 3.94 1.62 5.56c1.58 1.01 5 1.75 8.29 0 2-1.06 3.57-3.18 5.69-6.18z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M226.05 371.79c-.1-2.33-2.23-2.33-3.34-1.11-1.11 1.21-2.53 2.33-2.53 2.33l-1.62-.2-5.77-4.25s0-5.36-1.21-5.56-5.06 1.01-6.37.51c-1.32-.51-2.23-1.21-2.23-.81 0 0-.81-.3-1.52-1.62-.71-1.31-1.11-2.93.3-4.55 1.42-1.62 11.53-4.15 15.07-3.54 3.54.61 8.19 2.53 9.51 6.98s-.1 12.95-.1 12.95l-.42.13c.16-.48.25-.9.23-1.26z"
  })), _linearGradient68 || (_linearGradient68 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "au",
    x1: 179.905,
    x2: 258.222,
    y1: 488.638,
    y2: 608.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#270036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#4f008b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c24b1"
  }))), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#au)",
    d: "M183.52 461.4s-2.28 12.59-6.07 27.01c-3.79 14.41-5.46 22.15-4.25 26.25 1.21 4.1 13.96 20.48 15.48 22.91 1.52 2.43 21.54 21.7 21.54 21.7s4.1-6.98 5.77-13.65l1.67-6.68s-25.34-22.91-25.34-23.52.61-11.08.61-11.08 2.12-29.58 1.82-30.04c-.3-.46-8.19-11.83-8.19-11.83l-3.04-1.07z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M217.65 538.93s2.73.66 2.73 1.47c0 .81-1.82 9.71-1.72 12.34.1 2.63.71 8.9-.81 13.25s-4.35 6.78-5.97 6.17c-1.62-.61-2.33-1.42-1.82-3.14.51-1.72 2.53-6.57 2.02-7.99-.51-1.42-1.42-2.43-1.42-2.43s5.88-11.63 6.99-19.67z"
  })), _linearGradient69 || (_linearGradient69 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "av",
    x1: 203.045,
    x2: 187.873,
    y1: 469.651,
    y2: 561.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#270036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#4f008b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c24b1"
  }))), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#av)",
    d: "M220.79 469.29s-2.83 9.31-4.65 14.77c-1.82 5.46-3.49 11.48-6.37 33.33-2.88 21.85-8.34 54.01-8.34 54.01s-4.4.61-9.56-.61-7.59-3.34-7.59-3.34 7.59-42.33 8.5-61.75c.91-19.42.61-26.4-.91-28.83-1.52-2.43-4.25-6.52-5.01-9.71-.76-3.19-.3-4.7-.3-4.7s20.37 8.5 34.23 6.83z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M200.26 571.65s.61 2.43-.1 2.93c-.71.51-3.44 1.82-4.96 2.83s-4.15 3.64-9.31 4.45-5.46.91-7.08.3c-1.62-.61-3.14-1.72-3.14-1.72s.1-1.82 1.82-3.64 6.47-5.06 7.08-6.47c.61-1.42 1.01-2.12 1.01-2.12s4.97 3.84 14.68 3.44z"
  })), _linearGradient70 || (_linearGradient70 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aw",
    x1: 161.63,
    x2: 232.017,
    y1: 425.05,
    y2: 425.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1baff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#a7bfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#c3d3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    stopColor: "#d9e3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.274,
    stopColor: "#eaf0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#f6f8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#fdfeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aw)",
    d: "M216.44 409.51s-7.74 17.6-8.95 17.75-23.67-2.12-26.1-5.61-3.79-11.53-4.85-12.14c-1.06-.61-1.82-.46-1.82-.46s.05 7.64-.25 7.94c-.3.3-3.54.61-5.06-.3-1.52-.91-4.05-2.43-5.26-2.63-1.21-.2-3.14.61-2.33 1.62.81 1.01 2.83 2.83 2.83 2.83s.1 4.65 3.94 7.18c3.84 2.53 10.72 5.26 10.72 5.26s22.05 9.61 26.9 10.01 6.47-.61 9.31-2.63c2.83-2.02 9.91-11.13 13.15-16.08 3.24-4.96 3.34-6.98 3.34-6.98s-9.8-1.1-15.57-5.76z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M174.47 417c-.3.3-3.54.61-5.06-.3-1.52-.91-4.05-2.43-5.26-2.63 0 0-2.73-8.8-2.73-9.71 0-.91 10.92-1.01 11.43-.71s1.87 5.41 1.87 5.41.05 7.64-.25 7.94z"
  })), _linearGradient71 || (_linearGradient71 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ax",
    x1: 215.531,
    x2: 235.557,
    y1: 405.776,
    y2: 405.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#4e53ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.436,
    stopColor: "#2c6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.646,
    stopColor: "#1480ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#058cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  }))), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ax)",
    d: "m220.79 396.06-5.26 13.76s5.26 2.63 10.52 4.25 6.88 1.42 6.88 1.42 2.43-5.06 2.63-14.97"
  })), _linearGradient72 || (_linearGradient72 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ay",
    x1: 188.222,
    x2: 198.538,
    y1: 400.432,
    y2: 400.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#4e53ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.436,
    stopColor: "#2c6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.646,
    stopColor: "#1480ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#058cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  }))), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ay)",
    d: "M192.27 408.3s2.83-9.41 4.25-12.04c1.42-2.63 2.02-3.84 2.02-3.84s-4.25 3.84-7.28 9.31c-3.03 5.46-3.03 6.07-3.03 6.07s2.62 1.01 4.04.5z"
  })), _linearGradient73 || (_linearGradient73 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "az",
    x1: 255.798,
    x2: 368.292,
    y1: 294.422,
    y2: 294.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#311842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461,
    stopColor: "#190c4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000054"
  }))), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#az)",
    d: "M291.38 286.15s-23.39-11.2-27.04-11.3c-3.65-.1-7.49 2.73-8.33 5.36-.84 2.63.94 8.18 4.4 12.27 3.46 4.09 6.18 5.26 12.82 9.54 6.64 4.28 13.19 10.71 22.74 11.88 9.55 1.17 14.22-.49 22.93-.19 8.7.29 19.56-2.92 23.67-5.94 4.12-3.02 10.2-6.91 13.94-9.15s7.3-6.82 9.26-9.83c1.97-3.02 3.18-8.47 2.15-10.32-1.03-1.85-4.12-4.77-7.86-3.7-3.74 1.07-27.98 11.2-27.98 11.2l-40.7.18z"
  })), _linearGradient74 || (_linearGradient74 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aA",
    x1: 312.947,
    x2: 315.678,
    y1: 232.124,
    y2: 285.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1dacff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136,
    stopColor: "#1ca9fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.274,
    stopColor: "#1b9fef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414,
    stopColor: "#188eda"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#1476bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.696,
    stopColor: "#0f5898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#08326b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979,
    stopColor: "#010737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00002e"
  }))), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aA)",
    d: "M304.01 228.7s-14.13 3.31-16.38 5.36c-2.25 2.04-6.18 6.04-7.11 11.68-.94 5.65-.47 12.17-.47 12.17s1.31 1.85 7.2 2.73c5.9.88 5.15.68 5.15.68l-1.03 24.83s1.03 4.09 11.32 5.36c10.29 1.27 19.84.39 24.14-1.17 4.3-1.56 5.61-4.09 5.61-4.09s.75-14.31 1.03-18.4c.28-4.09.47-6.13.09-6.23-.37-.1 4.49-.58 9.08-3.41 4.59-2.82 5.61-3.7 5.61-3.7s-.19-16.16-5.43-19.86c-5.24-3.7-16.89-6.72-21.41-7.11-4.49-.4-17.4 1.16-17.4 1.16z"
  })), _linearGradient75 || (_linearGradient75 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aB",
    x1: 303.751,
    x2: 321.928,
    y1: 232.13,
    y2: 232.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1baff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#a7bfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#c3d3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    stopColor: "#d9e3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.274,
    stopColor: "#eaf0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#f6f8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#fdfeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aB)",
    d: "m304.17 227.16-.42 5.7s3.37 4.24 8.35 4.24c4.98 0 9.83-4.82 9.83-4.82l-.49-4.75"
  })), _linearGradient76 || (_linearGradient76 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aC",
    x1: 298.404,
    x2: 326.724,
    y1: 216.006,
    y2: 216.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1baff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#a7bfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#c3d3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    stopColor: "#d9e3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.274,
    stopColor: "#eaf0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#f6f8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#fdfeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aC)",
    d: "M300.24 211.54s-1.68-.8-1.82.88c-.14 1.68.84 6.21 1.68 6.57.84.37 1.4.51 1.4.51s.84 4.75 1.33 5.99c.49 1.24 5.82 5.92 7.3 6.35 1.47.44 5.05.58 6.95-.37 1.9-.95 5.12-4.82 6.11-7.01.98-2.19 1.05-5.04 1.05-5.04s1.4-.15 1.82-1.75c.42-1.61 1.12-6.13.21-6.65-.91-.51-.42-5.33-2.46-6.28-2.04-.95-19.16-6.06-20.42-4.67-1.26 1.39-2.18 4.53-2.32 5.48-.13.95-.83 5.99-.83 5.99z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M302.32 217.3s-.19-5.94-.09-6.23c.09-.29 1.12-5.06 1.12-5.06s2.62 1.75 10.48 1.95c7.86.19 9.17-.19 9.17-.19v9.74l.94-.19s.19-5.26 1.12-5.55c.94-.29 1.31-.29 1.31-.29s.09-11.98-.37-13.92c-.47-1.95-4.21-4.77-7.11-5.36-2.9-.58-13.94.1-17.4 2.92-3.46 2.82-2.99 3.9-3.09 7.21-.09 3.31.37 9.15.37 9.15s1.59-.29 1.78.39c.19.68.65 5.16.65 5.16l1.12.27z"
  })), _linearGradient77 || (_linearGradient77 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aD",
    x1: 280.209,
    x2: 316.383,
    y1: 270.227,
    y2: 270.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1baff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#a7bfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#c3d3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    stopColor: "#d9e3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.274,
    stopColor: "#eaf0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#f6f8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#fdfeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aD)",
    d: "M280.24 258.2c-.2-.09.56 5.92 2.81 14.53 2.25 8.62 3.09 11.03 3.79 11.76.7.73 4.35 1.1 6.88.07 2.53-1.02 8-5.55 10.46-9.13 2.46-3.58 4.91-6.72 4.91-6.72l.14-11.1 7.16-.51s-1.4-1.53-2.67-1.83c-1.26-.29-6.67 2.63-6.67 2.63l-3.93 8.76-8.63 3.43-.77-8.91c0 .02-6.11.31-13.48-2.98z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M321.08 277.92c0 .32-.25.58-.56.58h-10.81a.57.57 0 0 1-.56-.58v-19.94c0-.32.25-.58.56-.58h10.81c.31 0 .56.26.56.58v19.94z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M310 258.71h1.26v1.17H310z"
  })), _linearGradient78 || (_linearGradient78 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aE",
    x1: 298.276,
    x2: 324.384,
    y1: 293.092,
    y2: 293.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#7231fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.287,
    stopColor: "#682deb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461,
    stopColor: "#5625d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.646,
    stopColor: "#3e1baf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#1f0d83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000057"
  }))), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aE)",
    d: "M298.28 290.92s2.25 3.14 8.28 4.02c6.04.88 14.32-.15 15.93-1.17 1.61-1.02 1.9-2.78 1.9-2.78s-11.66 3.07-26.11-.07z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M308.8 291.87h7.79v4.31h-7.79zM305.69 304.74c-.37 0-17.59 1.46-19.93 2.63s-4.12 3.6-1.97 6.43c2.15 2.82 6.46 4.09 11.7 3.21 5.24-.88 16.75-5.06 16.75-5.06l-.56-1.46-5.99-5.75z"
  })), _linearGradient79 || (_linearGradient79 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aF",
    x1: 255.798,
    x2: 304.769,
    y1: 294.053,
    y2: 294.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#7231fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.287,
    stopColor: "#682deb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461,
    stopColor: "#5625d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.646,
    stopColor: "#3e1baf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#1f0d83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000057"
  }))), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aF)",
    d: "M295.03 293.06c-8.33-4.38-31.25-17.82-31.25-17.82s-.12-.14-.34-.35c-3.36.33-6.66 2.9-7.43 5.32-.84 2.63.94 8.18 4.4 12.27 2.89 3.41 5.27 4.8 9.83 7.65.69.33 1.32.61 1.86.82 5.71 2.24 26.39 12.27 26.39 12.27s1.87-.97 4.49-4.77 1.59-9.64 1.59-9.64-1.22-1.37-9.54-5.75z"
  })), _linearGradient80 || (_linearGradient80 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aG",
    x1: 303.447,
    x2: 316.36,
    y1: 305.036,
    y2: 305.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1baff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#a7bfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#c3d3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    stopColor: "#d9e3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.274,
    stopColor: "#eaf0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#f6f8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#fdfeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aG)",
    d: "m304.85 299.68 11.51 5.55s-1.4 0-1.87 1.95c-.47 1.95.09 3.21.09 3.21h-2.34l-8.8-2.92c.01 0 2.16-4.67 1.41-7.79z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M311.68 310.49s1.22 2.82 2.62 3.31c1.4.49 13.01 3.21 18.25 3.12 5.24-.1 8.14-1.17 8.7-4.87.56-3.7-2.43-4.58-5.9-5.06-3.46-.49-18.99-1.75-18.99-1.75s-1.68.58-1.87 1.95c-.19 1.36-.28 3.12-.28 3.12l-2.53.18z"
  })), _linearGradient81 || (_linearGradient81 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aH",
    x1: 311.681,
    x2: 320.102,
    y1: 302.213,
    y2: 302.213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1baff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#a7bfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#c3d3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    stopColor: "#d9e3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.274,
    stopColor: "#eaf0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#f6f8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#fdfeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aH)",
    d: "M311.68 302.99c.28-.19 7.49-4.09 7.49-4.09l.94 6.62-3.74-.29-4.69-2.24z"
  })), _linearGradient82 || (_linearGradient82 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aI",
    x1: 319.167,
    x2: 368.292,
    y1: 291.767,
    y2: 291.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#7231fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.287,
    stopColor: "#682deb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461,
    stopColor: "#5625d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.646,
    stopColor: "#3e1baf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#1f0d83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000057"
  }))), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aI)",
    d: "M361.05 274.57c-8.86 4.2-41.53 24.15-41.89 24.33l.94 6.62s7.58 1.17 12.82 1.36c4.46.17 6.95 1.67 7.59 2.11.79-.41 1.48-.83 2.04-1.24 4.12-3.02 10.2-6.91 13.94-9.15s7.3-6.82 9.26-9.83c1.97-3.02 3.18-8.47 2.15-10.32-.92-1.68-3.56-4.24-6.85-3.88z"
  })), _linearGradient83 || (_linearGradient83 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aJ",
    x1: 307.426,
    x2: 348.367,
    y1: 270.068,
    y2: 270.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1baff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#a7bfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#c3d3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    stopColor: "#d9e3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.274,
    stopColor: "#eaf0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#f6f8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#fdfeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aJ)",
    d: "M307.89 263.17c-.35.51-.84 1.24 0 2.26.84 1.02.77 1.39.77 1.39s-1.05 1.02-1.05 2.04.49 1.9.49 1.9-.42 1.46-.21 1.9l.21.44s-1.19 1.75 1.26 3.14c2.46 1.39 10.53 4.31 10.53 4.31s7.3 3.8 14.53 4.75c7.23.95 10.74-1.39 11.58-2.92.84-1.53 2.11-11.1 2.32-15.99.21-4.89-.28-11.76-.28-11.76s-2.24 2.7-7.79 4.75c-5.54 2.04-5.89 1.83-5.89 2.04 0 .22.21 7.96.49 9.49.28 1.53.84 2.85.84 2.85s-5.97.07-8.28.22c-2.32.15-3.93-.07-3.93-.07s1.47-3.36.7-5.33c-.77-1.97-1.47-3.72-1.33-4.75.14-1.02 0-1.46-.35-1.46s-1.54.37-1.68 1.39c-.14 1.02-.14 5.04-.14 5.04s-12.44-6.14-12.79-5.63z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M326.64 563.32s-1.21 1.01-4.45 1.42l-3.24.4s.71-6.07-.81-7.49-8.8-4.96-10.72-14.26 1.52-19.82 8.9-23.26c7.38-3.44 13.65-3.74 18.51.3 4.85 4.05 7.69 10.92 8.09 16.08.4 5.16.3 8.39.3 8.39l-16.58 18.42z"
  })), _linearGradient84 || (_linearGradient84 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aK",
    x1: 312.161,
    x2: 335.431,
    y1: 542.662,
    y2: 542.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1baff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#a7bfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#c3d3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    stopColor: "#d9e3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.274,
    stopColor: "#eaf0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#f6f8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#fdfeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aK)",
    d: "M331.5 556.75s-5.36-4.55-7.08-4.25c-1.72.3-4.85 2.43-5.97 1.11-1.11-1.31-1.72-4.05-2.12-4.25-.4-.2-1.21-.71-1.11-1.31.1-.61.81-1.32.81-1.32s-1.21.71-1.42-.1c-.2-.81-.2-1.72-.2-1.72s-2.43.3-2.12-1.21c.3-1.52 1.42-4.85 1.01-6.07-.4-1.21-2.33-4.75 0-7.69 2.33-2.93 7.28-6.37 11.43-.91 4.15 5.46 5.06 8.5 7.49 10.22 2.43 1.72 3.74 2.93 3.03 4.25-.71 1.31-1.82 3.14-1.82 4.25 0 1.11.1 3.34.1 3.34l-.3 8.09-1.73-2.43z"
  })), _linearGradient85 || (_linearGradient85 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aL",
    x1: 322.733,
    x2: 306.22,
    y1: 552.825,
    y2: 583.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8990ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#8d95ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.086,
    stopColor: "#a5b0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#b9c6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.271,
    stopColor: "#c8d7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.393,
    stopColor: "#d3e3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561,
    stopColor: "#d9eaff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dbecff"
  }))), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aL)",
    d: "M291.34 572.93s-1.21 2.93 1.82 4.85c3.03 1.92 31.35 5.46 32.67 4.75 1.31-.71 7.79-12.24 7.79-12.24l-.3-13.35-1.82-.2s-3.34 2.93-5.56 7.49c-2.22 4.55-6.17 11.73-6.17 11.73s-11.03-.71-12.34-2.33c-1.31-1.62-3.14-4.75-4.65-4.75-1.52 0-4.25-.1-4.25-.1l-7.19 4.15z"
  })), _linearGradient86 || (_linearGradient86 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aM",
    x1: 333.456,
    x2: 389.149,
    y1: 566.918,
    y2: 566.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8815ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#8917ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.233,
    stopColor: "#9e42ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#af64ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.654,
    stopColor: "#ba7cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.843,
    stopColor: "#c28bff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c490ff"
  }))), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aM)",
    d: "M338.68 544.21s-4.35 3.14-4.85 6.37c-.51 3.24-.4 18.61-.2 19.72s6.17 19.12 10.42 19.32c4.25.2 7.48-3.64 13.45-3.14 5.97.51 19.93 1.32 24.98 1.52 5.06.2 6.57.51 6.57.51l.1-22.35s-7.89 1.72-13.45-.4-11.02-7.18-13.96-10.32c-2.93-3.14-9.81-10.22-23.06-11.23z"
  })), _linearGradient87 || (_linearGradient87 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aN",
    x1: 346.857,
    x2: 298.712,
    y1: 552.744,
    y2: 595.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1baff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#a7bfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#c3d3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    stopColor: "#d9e3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.274,
    stopColor: "#eaf0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#f6f8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#fdfeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aN)",
    d: "M336.1 547.39s-1.06 2.43-1.06 8.34-.3 26.85-.3 26.85-8.8.56-14.16-.15c-5.36-.71-11.43-2.83-11.43-2.83s-1.62-2.83-3.94-4.55c-2.33-1.72-6.07-6.17-6.47-5.87-.4.3-.4 1.01.1 3.03.5 2.02 1.11 3.74 1.11 3.74s-3.64.2-4.25-.81-3.14-7.69-3.14-7.69-.71 1.21-1.01 2.93c-.3 1.72.71 7.38 3.34 9.41 2.63 2.02 8.19 3.44 12.84 4.96s20.23 4.15 26.5 4.55c6.27.4 8.29.51 8.9-.1.61-.61 5.16-19.02 5.36-26.8.2-7.79-1.01-14.87-5.06-16.28-4.04-1.41-6.57.11-7.33 1.27z"
  })), _linearGradient88 || (_linearGradient88 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aO",
    x1: 288.208,
    x2: 299.132,
    y1: 567.374,
    y2: 567.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#4e53ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.436,
    stopColor: "#2c6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.646,
    stopColor: "#1480ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#058cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  }))), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aO)",
    d: "M293.37 569.7s-5.16-7.69-5.16-8.29 5.56.4 5.56.4l4.96 7.38s-.3 1.42-.1 2.23c.2.81.51 2.12.51 2.12l-4.05-.1-1.72-3.74z"
  })), _linearGradient89 || (_linearGradient89 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aP",
    x1: 388.828,
    x2: 439.873,
    y1: 575.404,
    y2: 575.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#4e53ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.436,
    stopColor: "#2c6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.646,
    stopColor: "#1480ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#058cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  }))), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aP)",
    d: "M389.15 566.16s10.67-5.71 17.04-5.41c6.37.3 12.9 6.52 17.9 7.89 5.01 1.37 15.78 3.64 15.78 3.64l-.76 17.6s-29.43.46-38.84 0-11.23-1.37-11.23-1.37-.55-18.46.11-22.35z"
  })), _linearGradient90 || (_linearGradient90 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aQ",
    x1: 439.115,
    x2: 476.041,
    y1: 546.393,
    y2: 546.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1baff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#a7bfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#c3d3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    stopColor: "#d9e3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.274,
    stopColor: "#eaf0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#f6f8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#fdfeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aQ)",
    d: "M439.82 572.83s4.45 1.11 9.31 2.43c4.85 1.32 5.87 1.11 5.87 1.11s-1.42-11.53-.71-16.59c.71-5.06 3.34-15.37 3.74-18.61.4-3.24.4-4.55 0-5.36-.4-.81-1.11-1.32-1.11-1.32s-1.62 0-3.64-1.62-4.25-4.75-4.25-4.75 11.63-13.96 17.6-19.52c5.97-5.56 8.39-6.27 9.1-5.36.71.91.2 3.74-1.42 6.68-1.62 2.93-6.17 13.76-6.57 17.6s.1 24.17 1.01 38.44c.91 14.26 1.62 20.33 1.01 21.64-.61 1.32-3.24 1.92-3.24 1.92l-27.41.35.71-17.04z"
  })), _linearGradient91 || (_linearGradient91 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aR",
    x1: 449.027,
    x2: 476.041,
    y1: 518.705,
    y2: 518.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#4e53ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.436,
    stopColor: "#2c6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.646,
    stopColor: "#1480ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#058cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  }))), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aR)",
    d: "M466.63 508.6c-5.97 5.56-17.6 19.52-17.6 19.52s2.22 3.14 4.25 4.75c2.02 1.62 3.64 1.62 3.64 1.62s.81-7.49 5.06-13.05c3.95-5.17 6.86-8.86 10.74-8.21.64-1.43 1.21-2.61 1.6-3.33 1.62-2.93 2.12-5.77 1.42-6.68-.72-.89-3.15-.18-9.11 5.38z"
  })), _linearGradient92 || (_linearGradient92 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aS",
    x1: 457.273,
    x2: 420.255,
    y1: 572.409,
    y2: 530.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1baff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#a7bfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#c3d3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    stopColor: "#d9e3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.274,
    stopColor: "#eaf0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#f6f8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#fdfeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aS)",
    d: "M449.13 575.26c4.85 1.32 5.87 1.11 5.87 1.11s-.87-7.13-.9-12.64c-3.06-3.44-14.11-15.87-19.22-21.24-5.97-6.27-9.61-21.14-9.81-21.44-.2-.3-.3-1.92-.51-2.83s-2.73-6.17-4.05-6.88c-1.32-.71-3.03 4.15-2.83 11.93.2 7.79.71 24.78.71 24.78s4.25.81 6.07.71c1.82-.1 3.44-1.52 3.44-1.52s1.01 0 1.72.71 3.44 6.07 6.37 11.83c2.34 4.6 5.96 11.38 7.34 13.94 1.62.42 3.67.96 5.8 1.54z"
  })), _linearGradient93 || (_linearGradient93 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aT",
    x1: 417.656,
    x2: 427.888,
    y1: 530.018,
    y2: 530.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#4e53ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.436,
    stopColor: "#2c6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.646,
    stopColor: "#1480ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#058cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  }))), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aT)",
    d: "M422.02 526.2c.3-3.24 2.83-5.77 2.83-5.77.01 0 .02-.01.04-.01-.11-.64-.2-1.59-.34-2.21-.2-.91-2.73-6.17-4.05-6.88-1.32-.71-3.03 4.15-2.83 11.93.2 7.79.71 24.78.71 24.78s4.25.81 6.07.71c1.82-.1 3.44-1.52 3.44-1.52-4.76-6.77-6.17-17.79-5.87-21.03z"
  })), _linearGradient94 || (_linearGradient94 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aU",
    x1: 320.396,
    x2: 287.05,
    y1: 541.301,
    y2: 568.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    stopColor: "#7633ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.092,
    stopColor: "#7051ff",
    stopOpacity: 0.088
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.263,
    stopColor: "#6685ff",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5eb1ff",
    stopOpacity: 0.428
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.591,
    stopColor: "#57d3ff",
    stopOpacity: 0.589
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "#53ebff",
    stopOpacity: 0.742
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#50faff",
    stopOpacity: 0.883
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4fffff"
  }))), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aU)",
    d: "m308.93 526.15-15.16 35.66 4.38 6.72 33.35-11.78"
  })), _linearGradient95 || (_linearGradient95 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aV",
    x1: 245.637,
    x2: 142.841,
    y1: 339.877,
    y2: 422.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    stopColor: "#7633ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.092,
    stopColor: "#7051ff",
    stopOpacity: 0.088
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.263,
    stopColor: "#6685ff",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5eb1ff",
    stopOpacity: 0.428
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.591,
    stopColor: "#57d3ff",
    stopOpacity: 0.589
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "#53ebff",
    stopOpacity: 0.742
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#50faff",
    stopOpacity: 0.883
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4fffff"
  }))), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aV)",
    d: "m229.05 316.56-67.63 87.8 11.43-.71 1.87 5.41 54.31-19.22"
  })), _linearGradient96 || (_linearGradient96 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aW",
    x1: 321.473,
    x2: 310.572,
    y1: 90.47,
    y2: 298.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    stopColor: "#7633ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.092,
    stopColor: "#7051ff",
    stopOpacity: 0.088
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.263,
    stopColor: "#6685ff",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5eb1ff",
    stopOpacity: 0.428
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.591,
    stopColor: "#57d3ff",
    stopOpacity: 0.589
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "#53ebff",
    stopOpacity: 0.742
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#50faff",
    stopOpacity: 0.883
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4fffff"
  }))), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aW)",
    d: "m233.69 84.28 75.53 173.34 11.3-.22 88.95-164.94"
  })), _linearGradient97 || (_linearGradient97 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aX",
    x1: 407.327,
    x2: 509.092,
    y1: 145.69,
    y2: 219.626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    stopColor: "#7633ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.092,
    stopColor: "#7051ff",
    stopOpacity: 0.088
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.263,
    stopColor: "#6685ff",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5eb1ff",
    stopOpacity: 0.428
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.591,
    stopColor: "#57d3ff",
    stopOpacity: 0.589
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "#53ebff",
    stopOpacity: 0.742
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#50faff",
    stopOpacity: 0.883
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4fffff"
  }))), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aX)",
    d: "m363.29 203.61 63.06 55.57 5.82-21.06 34.36-1.74-12.61-156.51"
  })), _linearGradient98 || (_linearGradient98 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aY",
    x1: 559.847,
    x2: 605.233,
    y1: 382.136,
    y2: 396.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    stopColor: "#7633ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.092,
    stopColor: "#7051ff",
    stopOpacity: 0.088
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.263,
    stopColor: "#6685ff",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5eb1ff",
    stopOpacity: 0.428
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.591,
    stopColor: "#57d3ff",
    stopOpacity: 0.589
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "#53ebff",
    stopOpacity: 0.742
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#50faff",
    stopOpacity: 0.883
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4fffff"
  }))), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aY)",
    d: "m553.42 403.16 42.33 3.12 6.37-.08 3.87-12.67-6-.07-32.61-32.02"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMediaUsers);
export default __webpack_public_path__ + "static/media/social-media-users.0e27914b813801e53347fc71290e578f.svg";
export { ForwardRef as ReactComponent };